import { uid } from 'radash';

import { StateOfChargeDeratingHelpers } from '@diagram/helpers/StateOfChargeDeratingHelpers';

import { ComponentInstanceValidationError, ComponentInstanceValidator } from 'models';

const stateOfChargeDerating: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const errors: ComponentInstanceValidationError[] = [];

    Object.values(diagram.componentInstances).forEach((componentInstance) => {
        componentInstance.configuration.ports.forEach((_, portIndex) => {
            const type = StateOfChargeDeratingHelpers.getErrorType(diagram, componentInstance, portIndex);

            if (type) {
                errors.push({ id: uid(6), type, level: 'error', payload: { componentInstance, portIndex } });
            }
        });
    });

    return errors;
};

export { stateOfChargeDerating };
